import React, { useEffect } from 'react';

const useDebounce = (value, delay = 1000) => {
	const [debouncedValue, setDebouncedValue] = React.useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value]);

	return debouncedValue;
};

export default useDebounce;
